module.exports = __webpack_public_path__ + "img/Cena.f5099420.webp";